import "./GasWaterHeaterService.module.css";
import Header from "@/reusable_sections/Header";
import WaterHeaterHero from "./sections/WaterHeaterHero";
import HeaterBrands from "./sections/HeaterBrands";
import WaterHeaterServices from "./sections/WaterHeaterServices";
import WaterHeaterFaq from "./sections/WaterHeaterFaq";
import HeaterCta from "./sections/HeaterCta";
import Footer from "@/reusable_sections/Footer";
export default function GasWaterHeaterServicePage() {
  return <div>
      <Header />
      <WaterHeaterHero />
      <HeaterBrands />
      <WaterHeaterServices />
      <WaterHeaterFaq />
      <HeaterCta />
      <Footer />
    </div>;
}